<div class="container-box p-3">
  <form
    [formGroup]="form"
    [formEditablePermission]="form"
    class=""
    [class.loading-section]="isSavingDetailInfo$ | async"
  >
    <h6 class="text-uppercase" i18n>Rental description</h6>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block">
              <mat-select formControlName="type" i18n-placeholder placeholder="Rental Type">
                <mat-option *ngFor="let t of types" [value]="t">{{ t }}</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block">
              <mat-select formControlName="checkin_type" i18n-placeholder placeholder="Checkin Type">
                <mat-option *ngFor="let t of checkinTypes" [value]="t.id">{{
                  getCheckinTypeName(t.id) || t.name
                }}</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block">
              <input
                type="number"
                matInput
                min="0"
                formControlName="bedrooms"
                i18n-placeholder
                placeholder="Bedrooms"
              />
              <mat-error *ngIf="form.get('bedrooms').hasError('min')" i18n> Min value is 0 </mat-error>
              <mat-error *ngIf="form.get('bedrooms').hasError('integer')" i18n> Value should be integer </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2
              class="mat-block"
              matTooltip="Only values in quarters as 1.25, 1.50, 1.75, 2.0 etc.. are allowed for this field"
              i18n-matTooltip
            >
              <input
                type="number"
                matInput
                min="0"
                step="0.25"
                formControlName="bathrooms"
                i18n-placeholder
                placeholder="Bathrooms"
              />
              <mat-error *ngIf="form.get('bathrooms').hasError('min')" i18n> Min value is 0 </mat-error>
              <mat-error *ngIf="form.get('bathrooms').hasError('step')" i18n>
                Invalid Value. Only value in quarters as 1.25, 1.50, 1.75, 2.0 etc.. are allowed
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block">
              <mat-select formControlName="size_metric" i18n-placeholder placeholder="Size Metric">
                <mat-option value="SQFT" i18n>SQFT</mat-option>
                <mat-option value="SQM" i18n>SQM</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block" i18n-matTooltip matTooltip="Specify the size of your rental.">
              <input type="text" matInput formControlName="size" [placeholder]="sizePlaceholder" />
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2
              class="mat-block"
              i18n-matTooltip
              matTooltip="Specify the minimum allowed guest on your rental."
              matTooltipPosition="above"
            >
              <input
                type="number"
                matInput
                min="1"
                step="1"
                i18n-placeholder
                formControlName="sleep_min"
                placeholder="Minimum Guest Count"
              />
              <mat-error *ngIf="form.get('sleep_min').hasError('max')">
                <ng-container i18n>Max value is</ng-container> {{ form.get('sleep_max').value }}
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2
              class="mat-block"
              i18n-matTooltip
              matTooltip="Specify the maximum allowed guest on your rental."
              matTooltipPosition="above"
            >
              <input
                type="number"
                matInput
                min="1"
                step="1"
                i18n-placeholder
                formControlName="sleep_max"
                placeholder="Maximum Guest Count"
              />
              <mat-error *ngIf="form.get('sleep_max').hasError('min')">
                <ng-container i18n>Min value is</ng-container> {{ form.get('sleep_min').value }}
              </mat-error>
            </mat-form-field2>
          </div>
        </div>
      </div>
      <div class="col-sm-6 position-relative">
        <mat-form-field2 class="mat-block" cdkOverlayOrigin #aiSuggestionsTrigger="cdkOverlayOrigin">
          <mat-label i18n>Description</mat-label>
          <textarea
            matInput
            formControlName="description"
            rows="14"
            i18n-placeholder
            placeholder="Enter description of the rental property"
          ></textarea>
        </mat-form-field2>
        <app-ai-suggestions-icon
          [entityId]="rental.id"
          [attachTo]="aiSuggestionsTrigger"
          [width]="aiSuggestionsTrigger.elementRef?.nativeElement.clientWidth"
          (apply)="onApplyAIDescription($event)"
          class="position-absolute"
          style="bottom: 2rem; right: 2rem"
        ></app-ai-suggestions-icon>
      </div>
    </div>
    <hr />
    <h6 class="text-uppercase mb-4" i18n>Additional Information</h6>
    <div class="row">
      <div class="col-sm-6">
        <div class="row gap-row-3">
          <div class="col-sm-6">
            <mat-checkbox
              i18n-matTooltip
              matTooltip="Specify if your property is suitable for children"
              matTooltipPosition="above"
              formControlName="children_allowed"
              class="mt-primary"
              i18n
            >
              Children Allowed
            </mat-checkbox>
          </div>
          <div class="col-sm-6">
            <mat-checkbox
              i18n-matTooltip
              matTooltip="Specify if a property is suitable for events"
              matTooltipPosition="above"
              formControlName="events_allowed"
              class="mt-primary"
              i18n
            >
              Events Allowed
            </mat-checkbox>
          </div>
          <div class="col-sm-6">
            <mat-checkbox
              i18n-matTooltip
              matTooltip="Specify if guests are allowed to smoke at the property"
              matTooltipPosition="above"
              formControlName="smoking_allowed"
              class="mt-primary"
            >
              <ng-container i18n>Smoking Allowed</ng-container>
            </mat-checkbox>
          </div>
          <div class="col-sm-6">
            <mat-checkbox
              matTooltip="Specify if your property is suitable for pets"
              matTooltipPosition="above"
              i18n-matTooltip
              formControlName="pets_allowed"
              class="mt-primary"
            >
              <ng-container i18n>Pets Allowed</ng-container>
            </mat-checkbox>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block minimum_age_input">
              <input
                i18n-matTooltip
                matTooltip="Specify the minimum age for a guest staying at the property"
                matTooltipPosition="above"
                type="number"
                formControlName="guest_minimum_age"
                matInput
                i18n-placeholder
                placeholder="Traveller age"
              />
              <mat-error *ngIf="form.get('guest_minimum_age').touched && form.get('guest_minimum_age').hasError('min')">
                <ng-container i18n>Value must be at least 0</ng-container>
              </mat-error>
              <mat-error *ngIf="form.get('guest_minimum_age').touched && form.get('guest_minimum_age').hasError('max')">
                <ng-container i18n>Value must be at most 200</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block">
              <mat-select formControlName="locale" i18n-placeholder placeholder="Locale">
                <mat-option *ngFor="let locale of locales" [value]="locale.id">{{ locale.name }}</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h6 class="text-uppercase" i18n>Rental Details</h6>
      <div class="selectable-items-container d-flex gap-3">
        <button
          class="selectable-item btn btn-light btn-circle"
          (click)="channelFilterForAmenityCtrl.setValue('')"
          [class.active]="!channelFilterForAmenityCtrl.value"
          i18n
        >
          ALL
        </button>
        <button
          class="selectable-item btn btn-light btn-circle"
          *ngFor="let channel of apiChannels$ | async"
          (click)="channelFilterForAmenityCtrl.setValue(channel.name)"
          [matTooltip]="channel.friendlyName"
          matTooltipPosition="above"
          [class.active]="channelFilterForAmenityCtrl.value === channel.name"
        >
          <img [src]="channel.name | channelIcon" alt="" style="max-width: 15px; max-height: 15px" />
        </button>
      </div>
    </div>
    <div class="row gap-row-3">
      <ng-container *ngFor="let detail of form['controls']['detail']['controls']; let i = index">
        <div
          formArrayName="detail"
          class="col-sm-3"
          *ngIf="isAmenityAvailable | call : details[i].id : channelFilterForAmenityCtrl.value : channelAmenities"
        >
          <mat-checkbox [formControlName]="i" [value]="detail.id" class="mt-primary">
            {{ details[i].name }}
            <ng-container *ngFor="let item of getIcons | call : details[i].id : channelAmenities : channelsById">
              <img [src]="item.name | channelIcon" class="channel-icon mr-1" height="15" [matTooltip]="item.label" />
            </ng-container>
          </mat-checkbox>
        </div>
      </ng-container>
      <div class="empty-channel-amenities" i18n>No available Amenity</div>
    </div>
  </form>
</div>
